var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 113,
    viewBox: "0 0 113 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.375 80.0416C46.3771 77.0754 51.2502 75.3333 56.5 75.3333C61.7498 75.3333 66.6229 77.0754 70.625 80.0416",
    stroke: "#ABABAB",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6251 56.5C73.2254 56.5 75.3334 53.338 75.3334 49.4375C75.3334 45.537 73.2254 42.375 70.6251 42.375C68.0247 42.375 65.9167 45.537 65.9167 49.4375C65.9167 53.338 68.0247 56.5 70.6251 56.5Z",
    fill: "#ABABAB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3751 56.5C44.9754 56.5 47.0834 53.338 47.0834 49.4375C47.0834 45.537 44.9754 42.375 42.3751 42.375C39.7747 42.375 37.6667 45.537 37.6667 49.4375C37.6667 53.338 39.7747 56.5 42.3751 56.5Z",
    fill: "#ABABAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41675 56.5C9.41675 34.3049 9.41675 23.2074 16.3097 16.3097C23.2122 9.41666 34.305 9.41666 56.5001 9.41666C78.6952 9.41666 89.7927 9.41666 96.6857 16.3097C103.583 23.2121 103.583 34.3049 103.583 56.5C103.583 78.6951 103.583 89.7926 96.6857 96.6856C89.7974 103.583 78.6952 103.583 56.5001 103.583C34.305 103.583 23.2075 103.583 16.3097 96.6856C9.41675 89.7973 9.41675 78.6951 9.41675 56.5Z",
    stroke: "#ABABAB",
    strokeWidth: 7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.f7cbe2f09c91affcd70db3facad103ef.svg";
export { ForwardRef as ReactComponent };